import React from 'react';
import { Trans } from '@lingui/macro';
import styled from 'styled-components';
import { Media, Text, Box } from '@landr/maestro';
import { LrLogo } from '../../SVGs';

interface LogoProps {}

const VerticalAlignBox = styled(Box)`
    display: flex;
    flex-direction: column;
`;

const LogoContainer = styled(Media.Image)`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Logo: React.FC<LogoProps> = () => (
    <Media align="center" sx={{ flex: '0 1 auto' }}>
        <LogoContainer>
            <LrLogo />
        </LogoContainer>
        <Media.Body>
            <VerticalAlignBox>
                <Text size={'sm'} contrast="low">
                    LANDR&copy; {new Date().getFullYear()}
                </Text>
                <Text size={'sm'} contrast="low">
                    <Trans>All rights reserved</Trans>
                </Text>
            </VerticalAlignBox>
        </Media.Body>
    </Media>
);

export default Logo;
